import { render, staticRenderFns } from "./ReadOnlyOrderItemList.vue?vue&type=template&id=cfa43eee&scoped=true&"
import script from "./ReadOnlyOrderItemList.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyOrderItemList.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyOrderItemList.vue?vue&type=style&index=0&id=cfa43eee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa43eee",
  null
  
)

export default component.exports